<template>
  <button
    :id="button.id"
    class="map-btn R-color"
    :style="coordinates"
    @click="collabdata($event)"
  ></button>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "MapButton",
  props: ["button"],
  data() {
    return {
      coordinates: "",
    };
  },
  methods: {
    ...mapActions(["collabdata"]),
  },
  created() {
    this.coordinates = `top: ${this.button.coordX}%; left: ${this.button.coordY}%;`;
  },
};
</script>
<style lang="scss" scoped>

</style>